import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";

class PropertyRecordHeader extends Component {
  basicReport = (internalID) => {
    this.props.showReport(undefined, "aReport", undefined, {
      optReportType: "basicprop",
      lookupID: internalID,
      internalID,
      reportID: 36,
    });
  };

  compReport = (internalID) => {
    this.props.showReport(undefined, "aReport", undefined, {
      optReportType: "compprop",
      lookupID: internalID,
      internalID,
      reportID: 31,
    });
  };

  render() {
    if (this.props.parcelId !== undefined) {
      const internalId = this.props.node.$.internalID;

      return (
        <Table.Row>
          <Table.Cell
            width={8}
            className={"icon-align-middle"}
            key={`row_prop_rec_header_${this.props.propIndex}`}
          >
            <Table>
              <Table.Body>
                <Table.Row className="report-sub-section-header">
                  <Table.Cell className={"text-center"}>Parcel Id</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{`${this.props.parcelId} [${this.props.propRecCount} records]`}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
          <Table.Cell width={8}>
            <div className={`no-print float-right`}>
              <Button
                className={"margin-left-10"}
                onClick={() => this.basicReport(internalId)}
              >
                Basic Report{" "}
                {this.props.basicReportPrice &&
                  ` - ${this.props.basicReportPrice}`}
              </Button>
              <Button
                className={"margin-left-10"}
                onClick={() => this.compReport(internalId)}
              >
                Comprehensive Report{" "}
                {this.props.compReportPrice &&
                  ` - ${this.props.compReportPrice}`}
              </Button>
            </div>
          </Table.Cell>
        </Table.Row>
      );
    }
    return null;
  }
}
export default PropertyRecordHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/PropertyRecordHeader.js